module.exports = "/assets/ba2fccfcbeb8a72d05213be15b5f5b98.png";